import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { NostrLoginProvider } from "@nostrify/react/login";
import { NostrProvider } from "@/components/NostrProvider";
import PrintGenerator from "@/pages/PrintGenerator";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 60_000,
      gcTime: 600_000,
      retry: 2,
    },
  },
});

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <NostrLoginProvider storageKey="popart-treasures:login">
        <NostrProvider>
          <PrintGenerator />
        </NostrProvider>
      </NostrLoginProvider>
    </QueryClientProvider>
  );
}
